export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10345.5988a331.jpg";